function personalisation() {
  const customizationProduct = document.querySelector('.customization_product');
  if (!customizationProduct) {
    document.querySelector('[data-shopify="payment-button"]')?.remove();
    return;
  }

  function handleChecked(el) {
    const isNoOption = el.value === 'no';
    const parent = el.closest('.product_properties');
    const layoutInput = el.closest('.layoutInput');

    const errorElement = parent.querySelector('.properties_custom__error');
    const noCustomInput = layoutInput.querySelector('.noCustom');
    const propertiesCustomInputs = layoutInput.querySelectorAll('.properties_custom input');
    const propertiesCustomDiv = layoutInput.querySelector('.properties_custom');

    errorElement.style.display = 'none';

    if (isNoOption) {
      noCustomInput.value = 'Customer requires no text';
      noCustomInput.removeAttribute('disabled');
      propertiesCustomInputs.forEach((input) => {
        input.setAttribute('disabled', 'disabled');
        input.style.display = 'none';
      });
      propertiesCustomDiv.style.display = 'none';
      document.querySelector('.add-to-cart[type="submit"]')?.removeAttribute('disabled');
      return;
    }

    noCustomInput.setAttribute('disabled', 'disabled');
    noCustomInput.value = '';
    propertiesCustomInputs.forEach((input) => {
      input.removeAttribute('disabled');
      input.style.display = 'block';
    });
    propertiesCustomDiv.style.display = 'block';
    document.querySelector('.add-to-cart[type="submit"]')?.setAttribute('disabled', true);
  }

  // Input validation
  document.querySelectorAll('.properties_custom input').forEach((input) => {
    input.addEventListener('keyup', function () {
      const value = this.value.trim();
      const parent = this.closest('.product_properties');
      const errorElement = parent.querySelector('.properties_custom__error');

      if (value === '') {
        errorElement && (errorElement.style.display = 'block');
        this.style.border = '1px solid red';
        document.querySelector('.add-to-cart[type="submit"]')?.setAttribute('disabled', true);
      } else {
        errorElement && (errorElement.style.display = 'none');
        this.style.borderColor = '#e3e3e3';
        document.querySelector('.add-to-cart[type="submit"]')?.removeAttribute('disabled');
      }
    });
  });

  // Initialize checked radio
  const checkedRadio = document.querySelector('.btn-radio__checked:checked');
  if (checkedRadio && checkedRadio.value === 'no') {
    handleChecked(checkedRadio);
  }

  // Handle Engraving Option toggle (if exists)
  const engraving = document.querySelector('[data-option-name="Engraving"] [type="radio"]:checked');
  const addToCartButton = document.querySelector('.add-to-cart[type="submit"]');

  function updateAddToCartState(radioButton) {
    if (radioButton?.value.toLowerCase() === 'yes') {
      addToCartButton?.setAttribute('disabled', true);
    } else {
      addToCartButton?.removeAttribute('disabled');
    }
  }

  updateAddToCartState(engraving);

  const engravingRadios = document.querySelectorAll('[data-option-name="Engraving"] [type="radio"]');
  engravingRadios.forEach((radio) => {
    radio.addEventListener('change', function () {
      updateAddToCartState(this);
    });
  });

  // Radio change listener
  document.addEventListener('change', function (event) {
    if (event.target.classList.contains('btn-radio__checked')) {
      handleChecked(event.target);
    }
  });
}

personalisation();
